/* Drukke Mama's — gedrag op de productpagina (PDP).
   - Variantgrid uitklappen ("Toon alle X varianten")
   - Aanbevolen extra's: totaal bijhouden en meesturen met de hoofd-CTA
   - Live sync van merkregel/variantnaam/sticky-prijs bij variantwissel
   - Deel-link kopiëren + toast
   - Sticky mobiele koopbalk
   Geen jQuery; werkt bovenop Dawn's product-info/product-form machinerie. */

(function () {
  'use strict';

  /* ---------- Helpers ---------- */

  function formatMoney(cents) {
    // 3295 -> "32<sup>95</sup>" (zoals snippets/dm-money.liquid)
    var whole = Math.floor(cents / 100);
    var rest = String(cents % 100).padStart(2, '0');
    var span = document.createElement('span');
    span.className = 'dm-price';
    span.append(String(whole));
    var sup = document.createElement('sup');
    sup.setAttribute('aria-hidden', 'true');
    sup.textContent = rest;
    span.append(sup);
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = ',' + rest;
    span.append(sr);
    return span;
  }

  var toastTimer;
  function showToast(message) {
    var toast = document.querySelector('[data-dm-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.hidden = true;
    }, 2200);
  }

  /* ---------- Variantgrid uitklappen ---------- */

  document.addEventListener('click', function (event) {
    var expand = event.target.closest('[data-dm-expand]');
    var collapse = event.target.closest('[data-dm-collapse-btn]');
    if (!expand && !collapse) return;
    var card = event.target.closest('[data-dm-variant-card]');
    if (!card) return;
    var open = !!expand;
    card.classList.toggle('is-open', open);
    var lessRow = card.querySelector('[data-dm-less-row]');
    if (lessRow) lessRow.hidden = !open;
    if (!open) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Variantcarrousel (mobiel) ---------- */

  /* Op mobiel is het variantgrid een horizontale carrousel (CSS). Wie binnenkomt
     op een variant-URL moet die variant meteen zien staan, niet ergens buiten
     beeld rechts. Handmatig scrollLeft zetten i.p.v. scrollIntoView, zodat de
     pagina zelf niet verspringt. */
  function revealSelectedVariant() {
    document.querySelectorAll('.dm-vargrid--rich').forEach(function (track) {
      if (track.scrollWidth <= track.clientWidth) return;
      var checked = track.querySelector('input:checked');
      var card = checked && checked.closest('.dm-varopt');
      if (!card) return;
      var offset = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
      var center = (track.clientWidth - card.offsetWidth) / 2;
      track.scrollLeft = Math.max(0, track.scrollLeft + offset - center);
    });
  }

  /* ---------- Aanbevolen extra's ---------- */

  function extrasState() {
    var wrap = document.querySelector('[data-dm-extras]');
    if (!wrap) return null;
    var checked = Array.from(wrap.querySelectorAll('[data-dm-extra]:checked'));
    return {
      wrap: wrap,
      checked: checked,
      sum: checked.reduce(function (acc, box) {
        return acc + (parseInt(box.dataset.price, 10) || 0);
      }, 0),
    };
  }

  function updateExtrasTotals() {
    var state = extrasState();
    if (!state) return;
    var base = parseInt(state.wrap.dataset.dmBasePrice, 10) || 0;
    var totalEl = state.wrap.querySelector('[data-dm-extras-total]');
    if (totalEl) {
      totalEl.textContent = '';
      totalEl.append(formatMoney(base + state.sum));
    }
    var countEl = state.wrap.querySelector('[data-dm-extras-count]');
    if (countEl) {
      countEl.textContent =
        state.checked.length === 0
          ? "Geen extra's geselecteerd"
          : state.checked.length === 1
            ? "1 extra toegevoegd"
            : state.checked.length + " extra's toegevoegd";
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-dm-extra]')) updateExtrasTotals();
  });

  /* Aangevinkte extra's gaan mee met de hoofd-CTA: vlak vóór Dawn's eigen
     submit-afhandeling voegen we ze in één stille cart/add-call toe en laten we
     daarna de normale form-submit (hoofdproduct + cart-notificatie) doorlopen.
     Capture op document zodat dit vóór product-form.js draait. */
  var extrasPending = false;
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      if (extrasPending) {
        extrasPending = false;
        return;
      }
      var state = extrasState();
      if (!state || state.checked.length === 0) return;

      event.preventDefault();
      event.stopPropagation();

      var items = state.checked.map(function (box) {
        return { id: parseInt(box.dataset.variantId, 10), quantity: 1 };
      });
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .catch(function () {
          /* extra's konden niet toegevoegd worden; hoofdproduct gaat wel door */
        })
        .finally(function () {
          state.checked.forEach(function (box) {
            box.checked = false;
          });
          updateExtrasTotals();
          extrasPending = true;
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        });
    },
    true
  );

  /* ---------- Variantwissel: elementen live bijwerken ---------- */

  function initVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data) return;
      if (data.html) {
        document.querySelectorAll('[data-dm-sync]').forEach(function (el) {
          if (!el.id) return;
          var source = data.html.getElementById(el.id);
          if (source) el.innerHTML = source.innerHTML;
        });
      }
      if (data.variant) {
        var wrap = document.querySelector('[data-dm-extras]');
        if (wrap) {
          wrap.dataset.dmBasePrice = data.variant.price;
          updateExtrasTotals();
        }
      }
    });
  }

  /* ---------- Deel-link kopiëren ---------- */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dm-copy]');
    if (!button) return;
    var url = button.dataset.url || window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(function () {
          showToast('Link gekopieerd!');
        })
        .catch(function () {
          showToast('Kopiëren lukte niet');
        });
    }
  });

  /* ---------- Sticky mobiele koopbalk ---------- */

  /* De balk staat op mobiel altijd in beeld (zichtbaarheid regelt de CSS), zodat
     de koopknop niet pas na scrollen verschijnt. JS houdt hem alleen in sync met
     de hoofd-CTA (uitverkocht/beschikbaar) en handelt de klik af. */
  function syncStickyState() {
    var bar = document.querySelector('[data-dm-sticky]');
    if (!bar) return;
    var stickyButton = bar.querySelector('[data-dm-sticky-add]');
    var mainButton = document.querySelector('[data-dm-cta] button[name="add"]');
    if (!stickyButton || !mainButton) return;
    stickyButton.disabled = mainButton.disabled;
    var label = stickyButton.querySelector('[data-dm-sticky-label]');
    if (label) label.textContent = mainButton.disabled ? 'Uitverkocht' : 'In winkelmandje';
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-dm-sticky]');
    if (!bar) return;

    syncStickyState();

    // Dawn schakelt de hoofdknop om bij variantwissel (en bij een onbeschikbare
    // combinatie zónder variantChange-event); volg simpelweg zijn disabled-staat.
    var mainButton = document.querySelector('[data-dm-cta] button[name="add"]');
    if (mainButton && typeof MutationObserver === 'function') {
      new MutationObserver(syncStickyState).observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
    }

    // De knop is via het form-attribuut aan het product-formulier gekoppeld en
    // verstuurt dus zelf; Dawn's product-form.js vangt de submit af voor AJAX.
  }

  function init() {
    initVariantSync();
    initStickyBar();
    updateExtrasTotals();
    revealSelectedVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
